var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [{ name: "tooltip", rawName: "v-tooltip" }],
      ref: "addToWishList",
      staticClass: "btn btn-outline-light btn-lg btn-block",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        title: _vm.tooltipText,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.switchState()
        },
      },
    },
    [
      _c("i", {
        staticClass: "fa fa-regular fa-heart",
        class: _vm.isVariationInWishList ? "added" : "",
        staticStyle: { color: "#ffffff" },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Auf die Wunschliste")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }